
























































import { Component, Vue } from 'vue-property-decorator';
import { IUserProfile } from '@/interfaces';
import { readAdminUsers, dispatchGetUsers, dispatchDeleteUser, dispatchDeleteUsers } from '@/store/admin/accessors';

@Component
export default class AdminUsers extends Vue {
  public selected: IUserProfile[] = [];
  public pagination: { rowsPerPage; footerProps } = {
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };
  public headers = [
    {
      text: this.$vuetify.lang.t('$vuetify.login'),
      sortable: true,
      value: 'login',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.email'),
      sortable: true,
      value: 'email',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.fullName'),
      sortable: true,
      value: 'full_name',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.isActive'),
      sortable: true,
      value: 'is_active',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.isSuperuser'),
      sortable: true,
      value: 'is_superuser',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.actions'),
      value: 'id',
    },
  ];

  get users() {
    return readAdminUsers(this.$store);
  }

  get currentUser() {
    return this.$store.state.main.userProfile;
  }

  public async mounted() {
    await dispatchGetUsers(this.$store);
  }

  public async deleteUser(id: number) {
    if (confirm(this.$vuetify.lang.t('$vuetify.deleteUsersConfirmation'))) {
      await dispatchDeleteUser(this.$store, id);
      await dispatchGetUsers(this.$store);
    }
  }

  public async deleteUsers() {
    if (confirm(this.$vuetify.lang.t('$vuetify.deleteUsersConfirmation'))) {
      const selected = this.selected.map((item) => item.id as number);
      await dispatchDeleteUsers(this.$store, selected);
      await dispatchGetUsers(this.$store);
    }
  }
}
